<template>
  <EcxDialog
    :visible="props.visible"
    @update:visible="emit('update:visible', $event)"
    title="Change Tenant"
    size="md"
    cancelLabel="Cancel"
    actionLabel="Apply"
    :actionDisabled="selected === toRadioValue(props.current)"
    actionDisabledReason="Already the active tenant"
    testId="change-tenant-dialog"
    @action="onApply"
  >
    <div class="flex flex-col gap-4">
      <EcxCallout
        severity="primary"
        align="start"
        title="Tenant controls which sites you see"
        description="Work orders, tasks, assets, moratoria and reports are limited to that tenant's sites. Shared reference data such as categories is unaffected. Switching reloads the app and clears your grid filters."
      />

      <div role="radiogroup" aria-label="Tenant" class="flex flex-col gap-1">
        <label
          v-for="option in props.options"
          :key="option.value"
          class="flex cursor-pointer items-center gap-3 rounded-md px-2 py-2 text-sm text-content hover:bg-surface-hover"
        >
          <EcxRadioButton
            v-model="selected"
            :value="toRadioValue(option.value)"
            name="change-tenant"
            size="sm"
          />
          {{ option.label }}
        </label>
      </div>
    </div>
  </EcxDialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { EcxCallout, EcxDialog, EcxRadioButton } from '@edgeconnex/design-system';
import { fromRadioValue, toRadioValue } from './changeTenantModel';

defineOptions({ name: 'ChangeTenantDialog' });

const props = defineProps<{
  visible: boolean;
  /** Radio options; '' is the sysadmin "All" sentinel. */
  options: { label: string; value: string }[];
  /** Currently active tenant ('' = All). */
  current: string;
}>();

const emit = defineEmits<{
  'update:visible': [value: boolean];
  'apply': [value: string];
}>();

// Mounted per open (parent uses v-if), so seeding once is enough. Radio values go through
// the collision-proof mapping in changeTenantModel (see rationale there).
const selected = ref(toRadioValue(props.current));

function onApply() {
  emit('apply', fromRadioValue(selected.value));
  emit('update:visible', false);
}
</script>
